/* eslint-disable radix */
import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleDeleteMenu(setLoading) {
  toast.info('Excluindo menu...');
  setLoading(true);
  const id = store.getState().Menu.idMenu;
  return api
    .delete(`Menu?pId=${id}`)
    .then(() => {
      toast.success('Menu excluido com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Erro ao excluir menu');
    });
}

export async function handleUpdateMenu(menu, setLoading) {
  await api
    .put('Menu', menu)
    .then(() => {
      toast.success('Atualização feita com sucesso');
      setLoading(false);
      return true;
    })
    .catch(() => {
      toast.error('Erro ao atualizar os dados, tente novamente');
      setLoading(false);
      return false;
    });
}

export async function handleRegisterMenu(menu, setLoading) {
  await api
    .post('Menu', menu)
    .then(() => {
      toast.success('Menu criado com sucesso');
      setLoading(false);
      return true;
    })
    .catch(() => {
      toast.error(
        'Erro ao cadastrar menu, verifique os dados e tente novamente'
      );
      setLoading(false);
      return false;
    });
}

export async function handleDeleteSubMenuEspec(setLoading) {
  setLoading(true);
  toast.info('Excluindo módulo', { autoClose: 1000 });
  const subMenuID = store.getState().SubMenu.idSubMenuEspec;
  await api
    .delete(`/MenuSub?pId=${subMenuID}`)
    .then(() => {
      toast.success('Módulo excluido com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error(
        'Erro ao excluir o módulo, atualize a página e tente novamente'
      );
    });
}

function handleLoadMenuData(loadOptions) {
  const moduloID = store.getState().Menu.idModulo;
  const params = {
    idModulo: moduloID,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/Menu?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

function handleLoadSubMenuEspecData(loadOptions) {
  const menuID = store.getState().Modulos.idMenu;
  const params = {
    idMenu: parseInt(menuID),
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/MenuSub?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleRemoveMenuSubMenu(key) {
  const url = `MenuSub?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Sub Menu deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridSubMenuEspecDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadSubMenuEspecData(loadOptions),
    remove: (key) => handleRemoveMenuSubMenu(key),
  }),
};

async function handleRemoveMenu(key) {
  const url = `Menu?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Menu deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridMenuDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadMenuData(loadOptions),
    remove: (key) => handleRemoveMenu(key),
  }),
};
